<template>
  <div class="list">
    <div class="content-wrapper">
      <div class="filter-wrapper">
        <p class="hint-text">老师通过自己渠道（如线下学生到线上上课）发展的学生，可以免费上课。</p>
        <button class="add-pupils" @click="GetStudentSourceShareUrl">马上邀请学生注册</button>
      </div>
      <p class="no-result" v-if="isEmpty(peopleList)">暂无生源列表</p>
      <table class="table" v-if="!isEmpty(peopleList)">
        <tr class="order-brief">
          <th class="black">
            姓名
          </th>
          <th class="border">
            手机号
          </th>
          <th class="border">
            注册日期
          </th>
          <th>
            结算率
          </th>
        </tr>
        <template v-for="(item,index) in peopleList">
          <tr class="order-brief">
            <td>
              {{decodeURIComponent(item.username)}}
            </td>
            <td>
              {{item.phone}}
            </td>
            <td>
              {{item.addtime}}
            </td>
            <td>
              {{parseFloat(item.proportion * 100) + '%'}}
            </td>
          </tr>
        </template>
      </table>
      <template v-if="!isEmpty(peopleList)&&peopleList.length>10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="totoalPage">
        </el-pagination>
      </template>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import Vue from 'vue';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        currentPage: 1,
        totoalPage: 1,
        peopleList: [],
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      GetStudentSourceShareUrl(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'GetStudentSourceShareUrl',
            id: this.id,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$alert(response.weburl, '请将以下链接发至学生', {
              customClass: 'self-message',
              confirmButtonText: '复制'
            }).then(action => {
              this.$copyText(response.weburl).then(function (e) {
//                alert('复制成功')
              }, function (e) {
                alert('复制失败，请重新用手动复制')
              })
            });
          }
        }).catch((err) => {
        })
      },
      QueryStudentSource(pageNumber){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'QueryStudentSource',
            id: this.id,
            pageno: pageNumber,
            pagesize: 10,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.peopleList = response.list;
          }
        }).catch((err) => {
        })
      }
    },

    created(){
      this.QueryStudentSource(1);
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .list
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .filter-wrapper
        margin-bottom: 20px
        padding-left: 10px
        height: 60px
        width: 100%
        font-size: 0
        background #fff
        box-sizing border-box
        .hint-text
          display: inline-block
          vertical-align: top
          padding-left: 30px
          line-height: 60px
          font-size: 16px
          color: #333
          font-weight: bold

        .add-pupils
          margin: 10px 0 0 20px
          display: inline-block
          width: 160px
          height: 40px
          line-height: 40px
          text-align: center
          font-size: 16px
          color: #fff
          border-radius: 4px
          background: #3399ff
      .no-result
        font-size: 18px
        color: #333
        text-align: center
      .table
        width: 1164px
        background: #ffffff
        text-align: center
        font-size: 0
        table-layout: fixed
        .order-brief
          border-bottom: 1px solid #e4e4e4
          &:last-child
            border: none
          th
            height: 40px
            line-height: 40px
            width: 194px
            font-size: 14px
            color: #999
            box-sizing: border-box
            &:first-child
              width: 244px
              border-right: 1px solid #e4e4e4
            &:last-child
              width: 144px
            &.black
              color: #000
            &.border
              position: relative
              &::after
                content: ''
                position: absolute
                top: 10px
                right: 0
                width: 0
                height: 20px
                border-right: 1px solid #e4e4e4

          td
            height: 50px
            line-height: 50px
            font-size: 14px
            color: #333
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            box-sizing: border-box


</style>
<style lang="stylus" rel="stylesheet/stylus" >
  .self-message
    .el-message-box__message p
      word-break:break-all
</style>



// WEBPACK FOOTER //
// src/page/pupils/pupilslist/PupilsList.vue